export default "__VITE_ASSET__c58f793a__"